import axios from 'axios';


export default axios.create({
    baseURL: 'http://41.231.36.242:8085/RESTfullApi/front/',
    headers: {
},
});
 

export const baseURL = 'http://41.231.36.242:8085/RESTfullApi/front/';

export const imageURL = 'http://41.231.36.242:8087/uploads/information/'


